import React from 'react';
import PropTypes from 'prop-types';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';

/**
 * Aviso — caixa de atenção, prazo, informação importante ou nota, no molde dos
 * folders: fundo claro na cor do tipo, barra grossa à esquerda e etiqueta em
 * caixa alta com ícone sobre a borda de cima. Os quatro tipos usam as cores da
 * faixa da marca. O texto são blocos do Volto guardados no próprio bloco
 * (`blocks` + `blocks_layout`), com negrito, links e listas.
 *
 * É uma nota (role="note") com o rótulo como nome; o ícone é só para a vista.
 */

const traco = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2.2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const TIPOS = {
  atencao: {
    nome: 'Atenção',
    icone: (
      <>
        <path d="M12 3 2 20.5h20L12 3z" {...traco} />
        <path d="M12 10v4.5M12 17.2v.3" {...traco} strokeWidth={2.4} />
      </>
    ),
  },
  prazo: {
    nome: 'Prazo',
    icone: (
      <>
        <circle cx="12" cy="12" r="9.5" {...traco} />
        <path d="M12 6.5V12l3.5 2.5" {...traco} />
      </>
    ),
  },
  importante: {
    nome: 'Importante',
    icone: (
      <>
        <circle cx="12" cy="12" r="9.5" {...traco} />
        <path d="M12 7v6M12 16.7v.3" {...traco} strokeWidth={2.4} />
      </>
    ),
  },
  nota: {
    nome: 'Nota',
    icone: (
      <>
        <circle cx="12" cy="12" r="9.5" {...traco} />
        <path d="M12 11v6M12 7.3v.3" {...traco} strokeWidth={2.4} />
      </>
    ),
  },
};

const AvisoView = ({ data = {}, metadata, properties, texto }) => {
  const tipo = TIPOS[data.tipo] ? data.tipo : 'nota';
  const rotulo = (data.rotulo || '').trim() || TIPOS[tipo].nome;
  const temTexto = (data.blocks_layout?.items || []).length > 0;
  if (texto === undefined && !temTexto) return null;

  return (
    <div
      className={`ag-aviso ag-aviso--${tipo}`}
      role="note"
      aria-label={rotulo}
    >
      <span className="ag-aviso__rotulo">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          {TIPOS[tipo].icone}
        </svg>
        <span>{rotulo}</span>
      </span>
      <div className="ag-aviso__texto">
        {texto !== undefined ? (
          texto
        ) : (
          <RenderBlocks
            metadata={metadata || properties}
            content={{ blocks: data.blocks, blocks_layout: data.blocks_layout }}
          />
        )}
      </div>
    </div>
  );
};

AvisoView.propTypes = {
  data: PropTypes.shape({
    tipo: PropTypes.string,
    rotulo: PropTypes.string,
    blocks: PropTypes.object,
    blocks_layout: PropTypes.object,
  }),
  metadata: PropTypes.object,
  properties: PropTypes.object,
  texto: PropTypes.node,
};

export default AvisoView;
